import React, { Fragment, useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { isEmpty } from "lodash";
import { connect } from "react-redux";
import {
  Spin,
  Tabs,
  Divider,
  Row,
  Col,
  Timeline,
  Empty,
  notification,
} from "antd";
import moment from "moment";
import "moment/locale/vi";
import PinDropOutlinedIcon from "@material-ui/icons/PinDropOutlined";
import UpdateOutlinedIcon from "@material-ui/icons/UpdateOutlined";
import logo from "../../assets/logo.png";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import { Detail } from "../../services/search";
import { getValueFromUrl } from "../../utils/getValueFromUrl";
import { setValueFilter } from "../../redux/actions/searchFilter";
import FooterLayout from "../../layouts/FooterLayout";
import {BASE_URL} from "../../requests/APIConfig";

moment.locale("vi");

const { TabPane } = Tabs;

function DetailDiploma({ setValueFilter }) {
  const history = useHistory();
  const params = getValueFromUrl(history) || {};

  const [loading, setLoading] = useState(false);
  const [diploma, setDiploma] = useState({});

  // detail diploma
  const [soHieu, setSoHieu] = useState('');

  const fetchData = async () => {
    setLoading(true);
    try {
      const regex = /-/gi;
      const soVaoSo = params.soVaoSo?.replace(regex, "/");
      const bangId = params.bangId;

      const res = await Detail({ keyword: soVaoSo, bangId: bangId });

      if (res) {
        const { data } = res;
        setLoading(false);
        setDiploma(data);
      }
    } catch (error) {
      notification.error({
        description: "Đã có lỗi xảy ra",
      });
    }
  };

  useEffect(() => {
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const { duongDanFileAnh, truongDuLieuTrongBangs, logVanBangs } = diploma;

  useEffect(() => {
    setSoHieu(diploma?.soHieu || '');
  }, [diploma])

  return (
    <Fragment>
      <Spin size="large" spinning={loading}>
        <div className="container">
          <div className="row">
            <Fragment>
              <div className="col-lg-1" />
              <div className="col-12 col-sm-12 col-md-12 col-lg-10">
                <div
                  className="d-flex align-items-center justify-content-between px-2 py-3"
                  style={{ borderBottom: "1px solid #f0f0f0" }}
                >
                  <ArrowBackIcon
                    style={{ cursor: "pointer", fontSize: 32 }}
                    onClick={() => {
                      if (history.length > 2) {
                        history.goBack();
                      } else {
                        history.push("/");
                      }
                    }}
                  />
                  <img
                    src={logo}
                    alt="JBCert Logo"
                    onClick={() => {
                      setValueFilter({
                        name: null,
                        year: "2021",
                        donViId: undefined,
                        visible: false,
                        keyword: null,
                      });
                      history.push("/");
                    }}
                    width={200}
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </div>
              <div className="col-lg-1" />
            </Fragment>

            <div className="col-lg-1" />
            <div className="col-12 col-sm-12 col-md-12 col-lg-10">
              {isEmpty(diploma) ? (
                <Empty className="my-3" />
              ) : (
                <div style={{ paddingBottom: 48 }}>
                  <header className="px-2 py-3 mt-3">
                    <h3 style={{ color: "#4a81d4", fontSize: 20 }}>
                      {diploma.loaiBang}
                    </h3>
                  </header>

                  <div className="row">
                    <div className="col-md-6">
                      <div
                        className="p-2"
                        style={{
                          boxShadow: "rgba(0, 0, 0, 0.16) 0px 1px 6px 0px",
                        }}
                      >
                        <img
                          className="img-fluid"
                          // src={`https://apistaging.jbcert.vn${duongDanFileAnh}`}
                          src={`${BASE_URL}${duongDanFileAnh}`}
                          alt={duongDanFileAnh}
                        />
                      </div>
                    </div>

                    <div className="col-md-6">
                      <aside
                        className="d-flex flex-column p-2"
                        style={{
                          lineHeight: "1.8",
                        }}
                      >
                        <span style={{ fontWeight: 600 }}>
                          Thông tin chi tiết
                        </span>

                        <Divider className="mt-0" />

                        {(truongDuLieuTrongBangs || []).map((field) => (
                          <div
                            key={field.truongDuLieuCode}
                            style={{ fontSize: 14 }}
                          >
                            {(field.kieuDuLieu === 2 || field.kieuDuLieu === null) ? null : (
                              <Row
                                style={{ borderBottom: "1px solid #f0f0f0" }}
                              >
                                <Col span={10}>
                                  <span>{field.tenTruongDuLieu}</span>
                                </Col>
                                <Col span={14}>
                                  <span style={{ fontWeight: 600 }}>
                                    {field.giaTri}
                                  </span>
                                </Col>
                              </Row>
                            )}
                          </div>
                        ))}

                        <div
                          style={{ fontSize: 14 }}
                        >
                          <Row
                            style={{ borderBottom: "1px solid #f0f0f0" }}
                          >
                            <Col span={10}>
                              <span>Số hiệu</span>
                            </Col>
                            <Col span={14}>
                                <span style={{ fontWeight: 600 }}>
                                  {soHieu}
                                </span>
                            </Col>
                          </Row>
                        </div>
                      </aside>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                      <main className="w-100 my-3">
                        <Tabs defaultActiveKey="1">
                          <TabPane tab="Thông tin học sinh" key="1">
                            <div className="row">
                              <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                <div className="mb-3" style={{ lineHeight: 2 }}>
                                  <h6
                                    className="mb-2"
                                    style={{ fontSize: 18, fontWeight: 600 }}
                                  >
                                    Thông tin học sinh
                                  </h6>

                                  <div className="d-flex flex-column">
                                    <div>
                                      <span className="mr-2">Họ và tên:</span>
                                      <span className="font-weight-bold">
                                        {diploma.hocSinh?.hoVaTen}
                                      </span>
                                    </div>

                                    <div>
                                      <span className="mr-2">Ngày sinh:</span>
                                      <span className="font-weight-bold">
                                        {diploma.hocSinh?.ngaySinh
                                          ? moment(
                                              diploma.hocSinh?.ngaySinh
                                            ).format("DD/MM/YYYY")
                                          : ""}
                                      </span>
                                    </div>

                                    <div>
                                      <span className="mr-2">Nơi sinh:</span>
                                      <span className="font-weight-bold">
                                        {diploma.hocSinh?.noiSinh}
                                      </span>
                                    </div>

                                    <div>
                                      <span className="mr-2">Giới tính:</span>
                                      <span className="font-weight-bold">
                                        {diploma.hocSinh?.gioiTinh}
                                      </span>
                                    </div>

                                    <div>
                                      <span className="mr-2">Dân tộc:</span>
                                      <span className="font-weight-bold">
                                        {diploma.hocSinh?.danToc}
                                      </span>
                                    </div>

                                    <div>
                                      <span className="mr-2">Niên khoá:</span>
                                      <span className="font-weight-bold">
                                        {diploma.hocSinh?.nienKhoa}
                                      </span>
                                    </div>

                                    <div>
                                      <span className="mr-2">
                                        Hộ khẩu thường trú:
                                      </span>
                                      <span className="font-weight-bold">
                                        {diploma.hocSinh?.hoKhauThuongTru}
                                      </span>
                                    </div>

                                    <div>
                                      <span className="mr-2">Trường học:</span>
                                      <span className="font-weight-bold">
                                        {diploma.hocSinh?.truongHoc}
                                      </span>
                                    </div>

                                    <div>
                                      <span className="mr-2">Lớp học:</span>
                                      <span className="font-weight-bold">
                                        {diploma.hocSinh?.lopHoc}
                                      </span>
                                    </div>
                                  </div>
                                </div>
                              </div>

                              <div className="col-12 col-sm-12 col-md-6 col-lg-6">
                                <div style={{ lineHeight: 2 }}>
                                  <h6
                                    className="mb-2"
                                    style={{ fontSize: 18, fontWeight: 600 }}
                                  >
                                    Kết quả tốt nghiệp
                                  </h6>

                                  <div className="d-flex flex-column mb-3">
                                    <div>
                                      <span className="mr-2">
                                        Hình thức đào tạo:
                                      </span>
                                      <span className="font-weight-bold">
                                        {diploma.hocSinh?.hinhThucDaoTao}
                                      </span>
                                    </div>

                                    <div>
                                      <span className="mr-2">Học lực:</span>
                                      <span className="font-weight-bold">
                                        {diploma.hocSinh?.hl}
                                      </span>
                                    </div>

                                    <div>
                                      <span className="mr-2">Hạnh kiểm:</span>
                                      <span className="font-weight-bold">
                                        {diploma.hocSinh?.hk}
                                      </span>
                                    </div>

                                    <div>
                                      <span className="mr-2">
                                        Xếp loại tốt nghiệp:
                                      </span>
                                      <span className="font-weight-bold">
                                        {diploma.hocSinh?.xepLoaiTotNghiep}
                                      </span>
                                    </div>

                                    <div>
                                      <span className="mr-2">
                                        Năm tốt nghiệp:
                                      </span>
                                      <span className="font-weight-bold">
                                        {diploma.hocSinh?.namTotNghiep}
                                      </span>
                                    </div>
                                  </div>

                                  <div className="mb-3">
                                    <h6
                                      className="mb-2"
                                      style={{ fontSize: 18, fontWeight: 600 }}
                                    >
                                      Điểm môn học
                                    </h6>
                                    {(diploma.hocSinh.diemMonHocs || []).map(
                                      (point) => (
                                        <Row
                                          style={{
                                            borderBottom: "1px solid #f0f0f0",
                                          }}
                                          key={point.codeMonHoc}
                                        >
                                          <Col span={10}>
                                            <span>{point.tenMonHoc}</span>
                                          </Col>
                                          <Col span={14}>
                                            <span style={{ fontWeight: 600 }}>
                                              {point.diem}
                                            </span>
                                          </Col>
                                        </Row>
                                      )
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </TabPane>
                          <TabPane tab="Nhật ký văn bằng" key="2">
                            <Timeline>
                              {(logVanBangs || []).length > 0 ? (
                                logVanBangs.map((log) => (
                                  <Timeline.Item key={log.logId} color="green">
                                    <p style={{ fontWeight: 600 }}>
                                      {log.hoTen}
                                    </p>
                                    <p>{log.hanhDong}</p>
                                    <div
                                      className="d-flex align-items-center mt-1"
                                      style={{
                                        fontSize: 12,
                                        fontStyle: "italic",
                                        opacity: "0.7",
                                        lineHeight: 1,
                                      }}
                                    >
                                      <span className="mr-2">
                                        <PinDropOutlinedIcon
                                          style={{
                                            fontSize: 12,
                                            marginRight: 4,
                                          }}
                                        />
                                        {log.ip}
                                      </span>
                                      <span>
                                        <UpdateOutlinedIcon
                                          style={{
                                            fontSize: 12,
                                            marginRight: 4,
                                          }}
                                        />
                                        {moment(log.thoiGian).fromNow()}
                                      </span>
                                    </div>
                                  </Timeline.Item>
                                ))
                              ) : (
                                <Empty />
                              )}
                            </Timeline>
                          </TabPane>
                        </Tabs>
                      </main>
                    </div>
                  </div>
                </div>
              )}
            </div>

            <div className="col-lg-1" />
          </div>
        </div>

        <FooterLayout />
      </Spin>
    </Fragment>
  );
}

export default connect(null, {
  setValueFilter,
})(DetailDiploma);
